//Quick View
const host = window.location.host;

$(document).ready(function () {
    $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function () {
        quickView();
    });
});

function quickView() {
    $('body').on("click", ".quick-view", function () {
        if ($('#quick-view').length == 0) {
            $('html').addClass('fancybox-lock');
            $("body").append('<div id="quick-view"></div>');
        }
        var product_handle = $(this).data('handle');
        var productID = $(this).data('product-id');
        var productMetafieldsId = '#product-metafields-' + productID;
        var buttonQuickview = $(this);
        $('#quick-view').addClass(product_handle);
        console.log('productMetafieldsId', productMetafieldsId);
        var metafieldData = $(productMetafieldsId).text();
        metafields = JSON.parse(metafieldData);
        //console.log(metafields);
        jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
            console.log(product);
            var title = product.title;
            var type = product.type;
            var vendor = product.vendor;
            var price = 0;
            var original_price = 0;
            var desc = product.description;
            var images = product.images;
            var variants = product.variants;
            var options = product.options;
            var tags = product.tags;

            //Add product tags
            $(tags).each(function (i, tag) {
                let tagHtml = '<span>' + tag.trim() + '</span>';
                $(tagHtml).appendTo('.qv-product-tags');
            });
            var url = '/products/' + product_handle;

            //Add product name
            $('.qv-product-title').text(vendor);
            $('.qv-product-type').text(title);
            //$('.qv-product-description').html(desc);
            $('.view-product').attr('href', url);
            var productUrl = $('#quick-view .wishlist button').data('product-url');
            $('#quick-view .wishlist button').attr('data-product-url', productUrl + url);
            $('#quick-view .wishlist button').attr('data-product-id', product.id);
            $('#quick-view .wishlist button').attr('data-variant-id', variants[0].id);
            let productDetailId = '#product-detail-' + product.id + ' .product--button-wishlist';
            if ($(productDetailId).hasClass('swym-added') || buttonQuickview.closest('.product--detail-wishlist').hasClass('swym-added')) {
                $('#quick-view .wishlist button').addClass('swym-added');
            }

            var imageCount = $(images).length;
            $(images).each(function (i, image) {
                if (i == imageCount - 1) {
                    var image_embed = '<div class="qv-product-image swiper-slide"><img src="' + image + '"></div>';
                    image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
                    $('.qv-product-images .swiper-wrapper').append(image_embed);

                    // $('.qv-product-images').slick({
                    //     'dots': false,
                    //     'arrows': false,
                    //     'respondTo': 'min',
                    //     'useTransform': false
                    // }).css('opacity', '1');

                } else {
                    image_embed = '<div class="qv-product-image swiper-slide"><img src="' + image + '"></div>';
                    image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
                    $('.qv-product-images .swiper-wrapper').append(image_embed);
                }
            });

            var swiperSlideQV = new Swiper('.qv-product-images', {
                //Optional parameters
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: {
                    el: '.qv-swiper-pagination',
                    type: "fraction",
                },
                // Navigation arrows
                navigation: {
                    nextEl: '.qv-collections-tab-next',
                    prevEl: '.qv-collections-tab-prev',
                },
            });

            const host = window.location.host;

            $(options).each(function (i, option) {
                var opt = option.name;
                if (opt.toLowerCase() == 'color') {
                    let swatchesHtml = '<div class="color-swatches">' +
                        '</div>';
                    $('.qv-product-options').append(swatchesHtml);
                    console.log(metafields);
                    $(option.values).each(function (i, value) {
                        let valueLower = value.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-');
                        let imageSrc = '//' + host + '/cdn/shop/files/' + value.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-') + '.jpg';
                        let colorMetafield = '';

                        //loop metafields
                        $(metafields).each(function (i, metafield) {
                            let metafieldLabel = metafield.label.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-');
                            console.log('imageSrc', imageSrc);
                            if (valueLower == metafieldLabel) {
                                imageSrc = metafield.image;
                                colorMetafield = metafield.color_taxonomy_reference;
                                console.log('valueLower', valueLower);
                                console.log('imageSrc', imageSrc);
                                console.log('colorMetafield', colorMetafield);
                            }
                        });

                        let swatchesItem = '<span class="swatch-item" data-product-handle="' + product_handle + '" data-value="' + value + '"><span>' + value + '</span><span><img src="' + imageSrc + '" data-color-swatch-metafield="' + colorMetafield + '" onerror="imgError(this,\'' + value.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-') + '\',\'' + colorMetafield + '\')" /></span></span>';

                        if (i == 0) {
                            swatchesItem = '<span class="swatch-item active" data-product-handle="' + product_handle + '" data-value="' + value + '"><span>' + value + '</span><span><img src="' + imageSrc + '" data-color-swatch-metafield="' + colorMetafield + '" onerror="imgError(this,\'' + value.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-') + '\',\'' + colorMetafield + '\')" /></span></span>';
                        }
                        $('.color-swatches').append(swatchesItem);
                    });
                }
                var selectClass = '.option.' + opt.toLowerCase();
                $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="option-' + i + ' option disable ' + opt.toLowerCase() + '"></select></div>');
                if (opt.toLowerCase() == 'size')
                    $('.option.' + opt.toLowerCase()).append('<option class="placeholder" disabled selected>- Select -</option>');
                $(option.values).each(function (i, value) {
                    $('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
                });
            });

            if (variants[0].compare_at_price != null && variants[0].compare_at_price != variants[0].price) {
                price = parseFloat(variants[0].price / 100).toFixed(2);
                original_price = parseFloat(variants[0].compare_at_price / 100).toFixed(2);

                //console.log(price)
                //console.log('original_price', original_price)
                let priceHtml = '<span class="price-item price-item--regular">$' + price + '</span>';
                let originalPriceHtml = '<span class="price-item price-item--sale price-item--last">$' + original_price + '</span>';
                $('.qv-product-price').empty();
                $(originalPriceHtml).appendTo('.qv-product-price');
                $(priceHtml).appendTo('.qv-product-price');

                let percent = (price - original_price) / original_price * 100;
                let percentTag = '<span class="percent">' + percent.toFixed(0) + '%</span>';
                $('.qv-product-tags .percent').remove();
                $('.qv-product-tags').append(percentTag);
            } else {
                price = parseFloat(variants[0].price / 100).toFixed(2);
                //console.log(price)
                let priceHtml = '<span class="price-item price-item--regular">$' + price + '</span>';
                $('.qv-product-price').empty();
                $(priceHtml).appendTo('.qv-product-price');
                $('.qv-product-tags .percent').remove();
            }

            let totalAvailable = false;
            for (var i = 0; i < variants.length; i++) {
                if (variants[i].available) totalAvailable = true;
            }

            if (totalAvailable) {
                $('.qv-add-button').prop('disabled', false).val('Add to Cart');
            } else {
                $('.qv-add-button').prop('disabled', true).val('Sold Out');
            }

            // let variantId = variants[0].id;
            // $('.qv-add-to-cart input[name="id"]').val(variantId);
        });

        $(document).on("click", ".swatch-item", function () {
            if (!$(this).hasClass('active')) {
                let color = $(this).data('value');
                $(this).closest('.color-swatches').find('.swatch-item').removeClass('active');
                $(this).addClass('active');
                $("#quick-view select.color").val(color).change();
                var size = '';
                if ($('#quick-view select').val() != null) {
                    size = $('#quick-view select').val()
                } else {
                    size = $('#quick-view select option:eq(1)').attr('value');
                }
                console.log('color', color);
                console.log('size', size);
                if (color && size) {
                    var selectedOptions = size + ' / ' + color;
                    console.log('selectedOptions', selectedOptions);
                    //console.log(selectedOptions);
                    product_handle = $(this).data('product-handle');
                    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
                        $(product.variants).each(function (i, v) {
                            console.log(v);
                            if (v.title == selectedOptions) {
                                let position = parseInt(v.featured_image.position) - 1;
                                console.log('position', position);
                                var swiperSlideQV = new Swiper('.qv-product-images', {
                                    //Optional parameters
                                    loop: false,
                                    slidesPerView: 1,
                                    spaceBetween: 0,
                                    pagination: {
                                        el: '.qv-swiper-pagination',
                                        type: "fraction",
                                    },
                                    // Navigation arrows
                                    navigation: {
                                        nextEl: '.qv-collections-tab-next',
                                        prevEl: '.qv-collections-tab-prev',
                                    },
                                });
                                if (position == 0) {
                                    position = 1;
                                    swiperSlideQV.slideTo(position);
                                    swiperSlideQV.slidePrev();
                                    $('.swiper-pagination-current').text('1');
                                } else {
                                    swiperSlideQV.slideTo(position);
                                    $('.swiper-pagination-current').text(position + 1);
                                }
                            }
                        });
                    });
                }
            }
        });

        $(document).on("click", "#quick-view .product--button-wishlist", function () {
            let productDetailId = '#product-detail-' + $(this).data('product-id') + ' .product--button-wishlist';
            $(productDetailId).click().trigger('click');
            $(productDetailId).toggleClass('swym-added').closest('.product-detail').toggleClass('swym-added');
            $(this).toggleClass('swym-added');
        });

        $(document).on("change", "#quick-view select", function () {
            var selectedOptions = '';
            $(this).removeClass('disable');
            $('#quick-view .qv-add-button').removeClass('disabled');
            $('#quick-view select').each(function (i) {
                if (selectedOptions == '') {
                    selectedOptions = $(this).val();
                } else {
                    selectedOptions = selectedOptions + ' / ' + $(this).val();
                }
            });
            //console.log(selectedOptions);
            jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
                $(product.variants).each(function (i, v) {
                    if (v.title == selectedOptions) {
                        //var price = parseFloat(v.price / 100).toFixed(2);
                        //var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
                        var v_qty = v.inventory_quantity;
                        var v_inv = v.inventory_management;
                        //$('.qv-product-price').text('$' + price);
                        //$('.qv-product-original-price').text('$' + original_price);

                        if (v.compare_at_price != null && v.compare_at_price != v.price) {
                            price = parseFloat(v.price / 100).toFixed(2);
                            original_price = parseFloat(v.compare_at_price / 100).toFixed(2);

                            //console.log(price)
                            //console.log('original_price', original_price)
                            let priceHtml = '<span class="price-item price-item--regular">$' + price + '</span>';
                            let originalPriceHtml = '<span class="price-item price-item--sale price-item--last">$' + original_price + '</span>';
                            $('.qv-product-price').empty();
                            $(originalPriceHtml).appendTo('.qv-product-price');
                            $(priceHtml).appendTo('.qv-product-price');

                            let percent = (price - original_price) / original_price * 100;
                            let percentTag = '<span class="percent">' + percent.toFixed(0) + '%</span>';
                            $('.qv-product-tags .percent').remove();
                            $('.qv-product-tags').append(percentTag);
                        } else {
                            price = parseFloat(v.price / 100).toFixed(2);
                            //console.log(price)
                            let priceHtml = '<span class="price-item price-item--regular">$' + price + '</span>';
                            $('.qv-product-price').empty();
                            $(priceHtml).appendTo('.qv-product-price');
                            $('.qv-product-tags .percent').remove();
                        }

                        if (v.available) {
                            $('.qv-add-button').prop('disabled', false).val('Add to Cart');
                        } else {
                            $('.qv-add-button').prop('disabled', true).val('Sold Out');
                        }

                        // let variantId = v.id;
                        // $('.qv-add-to-cart input[name="id"]').val(variantId);
                    }
                });
            });
        });

        $.fancybox({
            href: '#quick-view',
            maxWidth: '90%',
            maxHeight: '90%',
            fitToView: true,
            width: 887,
            height: 560,
            autoSize: false,
            closeClick: false,
            openEffect: 'none',
            closeEffect: 'none',
            hideScrollbar: false,
            padding: 0,
            'beforeLoad': function () {
                var product_handle = $('#quick-view').attr('class');
                $('.fancybox-wrap').css('overflow', 'hidden !important').addClass('quick-view-fancybox');
                $("#quick-view .qv-content").scrollbar();
            },
            'afterShow': function () {
                setTimeout(function () { $("#quick-view .qv-content").scrollbar() }, 100);
                $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
                    $('.qv-product-images').addClass('loaded');
                    $(document).on("click", ".qv-add-button", function () {
                        var qty = $('.qv-quantity').val();
                        var selectedOptions = '';
                        var var_id = '';
                        var obj = $(this);
                        $('#quick-view select').each(function (i) {
                            if (selectedOptions == '') {
                                selectedOptions = $(this).val();
                            } else {
                                selectedOptions = selectedOptions + ' / ' + $(this).val();
                            }
                        });
                        jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
                            $(product.variants).each(function (i, v) {
                                if (v.title == selectedOptions) {
                                    var_id = v.id;
                                    //console.log('var_id', var_id);
                                    processCart();
                                }
                            });
                        });
                        function processCart() {
                            jQuery.post('/cart/add.js', {
                                quantity: qty,
                                id: var_id
                            },
                                null,
                                "json"
                            ).done(function (data) {
                                $('.qv-add-to-cart-response').removeClass('error').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a class="btn link" href="/cart">Click here to view your cart.</a>');
                                $('#quick-view').removeClass().empty();
                                //console.log(data)
                                $.ajax({
                                    type: 'GET',
                                    url: '/cart.js',
                                    cache: false,
                                    dataType: 'json',
                                    success: function (cart) {
                                        //console.log(cart)
                                        var totalPrice = cart.total_price / 100;
                                        var itemCount = cart.item_count;
                                        var itemInfo;
                                        let i = 0;
                                        while (i < cart.items.length) {
                                            if (cart.items[i].variant_id == var_id) {
                                                itemInfo = cart.items[i];
                                                break;
                                            }
                                            i++;
                                        }
                                        //console.log(itemInfo);
                                        $('#counter').attr('data-count', itemCount);
                                        $('#counter .item-count').text(itemCount);
                                        $('.fancybox-close').click();
                                        $('body').addClass('open-cart');
                                        $('.main-header').addClass('main-header-active');
                                        let hasVariant = false;
                                        $('.main-header .productsInCart').each(function (index, element) {
                                            let itemVariantId = $(element).find('.variant-id').text();
                                            if (itemVariantId == var_id) {
                                                hasVariant = true;
                                                //console.log(itemInfo.quantity);
                                                $(element).find('.variant-quantity').text(itemInfo.quantity);
                                            } else {
                                                let itemLine = parseInt($(element).find('button').attr('data-cart-remove')) + 1;
                                                $(element).find('button').attr('data-cart-remove', itemLine);
                                            }
                                        });
                                        if (!hasVariant) {
                                            var itemHtml = '<x-grid columns="12" class="productsInCart" style="gap:var(--globalBorderWidth)">';
                                            itemHtml += '<span class="item-key" style="display: none" rv-text="item.key">48866655174959:5a5cf10c9bf83dbb234c2094c3663d81</span>';
                                            itemHtml += '<span class="variant-id" style="display: none" rv-text="item.variant_id">' + itemInfo.variant_id + '</span>';
                                            itemHtml += '<x-cell class="image" span="3" rv-show="item.image">';
                                            itemHtml += '<a rv-href="item.url | escape" class="no-style" href="' + itemInfo.url + '">'
                                            itemHtml += '<img width="200" loading="lazy" alt="Product image" style="margin-inline:auto;transform:none" src="' + itemInfo.image + '">'
                                            itemHtml += '</a>';
                                            itemHtml += '</x-cell>';

                                            itemHtml += '<x-cell class="name" span="9">';
                                            itemHtml += '<a rv-href="item.url | escape" class="no-style item-minicart-name" href="' + itemInfo.url + '">';
                                            itemHtml += '<span class="name" rv-text="item.product_title | escape">' + itemInfo.product_title + '</span>';
                                            itemHtml += '</a>';
                                            itemHtml += '<span class="product-variant">';
                                            itemHtml += '<span class="variant-item variant-vendor" rv-text="item.vendor">' + itemInfo.vendor + '</span>';
                                            itemHtml += '<span class="variant-item variant-title" rv-text="item.variant_title | escape">' + itemInfo.variant_title + '</span>';
                                            itemHtml += '<span class="variant-item variant-quantity" rv-html="item.quantity" aria-label="Quantity">' + itemInfo.quantity + '</span>';
                                            itemHtml += '</span>';
                                            itemHtml += '<ul rv-hide="item.propertyArray | empty" class="no-style cartProperties" style="display: none;"></ul>';
                                            itemHtml += '<p class="selling-plan smaller" rv-text="item.selling_plan_allocation.selling_plan.name"></p>';
                                            itemHtml += '<div class="item-price">';
                                            itemHtml += '<div';
                                            let finalPrice = itemInfo.final_line_price / 100;
                                            itemHtml += '<span class="price" rv-html="item.original_line_price | money">$' + finalPrice.toFixed(2) + '</span>';
                                            itemHtml += '</div>';
                                            itemHtml += '</div>';
                                            itemHtml += '</x-cell>';

                                            itemHtml += '<x-cell span="1" style="padding:0">';
                                            itemHtml += '<x-flex ai="center" jc="around" jc-s="between" wrap="wrap" class="controllers" style="gap:0 1rem">';
                                            itemHtml += '<x-cell>';
                                            itemHtml += '<button class="is-blank" rv-data-cart-remove="index | plus 1" data-cart-remove="1">';
                                            itemHtml += '<span class="visually-hidden">Remove</span>';
                                            itemHtml += '<span class="times remove"><i class="g-trash"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5488 16.5312L13.0176 12L17.5488 7.4688C17.6856 7.332 17.76 7.152 17.76 6.96C17.76 6.768 17.6856 6.588 17.5488 6.4512C17.268 6.1704 16.812 6.1704 16.5312 6.4512L12 10.9824L7.46879 6.4512C7.18799 6.1704 6.73199 6.1704 6.45119 6.4512C6.31439 6.588 6.23999 6.768 6.23999 6.96C6.23999 7.152 6.31439 7.332 6.45119 7.4688L10.9824 12L6.45119 16.5312C6.31439 16.668 6.23999 16.848 6.23999 17.04C6.23999 17.232 6.31439 17.412 6.45119 17.5488C6.72239 17.82 7.19759 17.82 7.46879 17.5488L12 13.0176L16.5312 17.5488C16.8024 17.82 17.2776 17.82 17.5488 17.5488C17.6856 17.412 17.76 17.232 17.76 17.04C17.76 16.848 17.6856 16.668 17.5488 16.5312Z" fill="currentColor"></path></svg></i></span>';
                                            itemHtml += '</button>';
                                            itemHtml += '</x-grid>';
                                            $(itemHtml).appendTo('section.cart x-cell.entry');

                                            //if (itemCount == 1) {
                                            $('section.cart .subtotal strong').text('$' + totalPrice.toFixed(2));
                                            $('section.cart .total strong').text('$' + totalPrice.toFixed(2));
                                            $('.cartCounter').removeClass('cartCounterEmpty');
                                            $('section.cart').removeClass('cart-empty');
                                            $('section.cart > div').show();
                                            $('section.cart .empty').hide();
                                            //}
                                        }
                                    }
                                });
                            })
                                .fail(function ($xhr) {
                                    var data = $xhr.responseJSON;
                                    $('.qv-add-to-cart-response').addClass('error').removeClass('success').html('<span><b>ERROR: </b>' + data.description);
                                });
                        }
                    });
                });
                //jQuery('.scrollbar-inner').scrollbar();
            },
            'afterClose': function () {
                $('#quick-view').removeClass().empty();
            }
        });
    });
};

$(window).resize(function () {
    if ($('#quick-view').is(':visible')) {
        //$('.qv-product-images').slick('setPosition');
        $("#quick-view .qv-content").scrollbar();
    }
});

function imgError(image, color, colorMetafield) {
    if (colorMetafield) {
        jQuery(image).parent().addClass('img-error').css('background-color', colorMetafield).append('<span class="div-for-img-error" style="background-color: ' + colorMetafield + '"></span>');
    } else {
        jQuery(image).parent().addClass('img-error').css('background-color', 'var(--color-swatch-' + color + ')').append('<span class="div-for-img-error" style="background-color: var(--color-swatch-' + color + ')"></span>');
    }
}